export function isMember(subscriptionExpiresAt: string | null) {
  if (!subscriptionExpiresAt) return false // null → not a member

  return new Date(subscriptionExpiresAt) > new Date() // active subscription → true
}
